/**
 * Super-Admin "View as" (impersonation) helpers.
 *
 * Flow: POST the start/stop endpoint (audited backend-side), flip the store's
 * `impersonateUserId`, then do a full page reload. The reload re-bootstraps
 * `/me` — now with (or without) the `X-Impersonate-User` header — and resets
 * every React-Query cache, so the whole app reflects the target persona
 * cleanly. Same UX as Salesforce "Login As" / ServiceNow "Impersonate".
 */
import { api } from '@/lib/api';
import { useAuthStore } from '@/store/auth';
/** Start "viewing as" the given user. Must be called by a Super Admin. */
export async function startImpersonation(userId) {
    // POST as the real admin (no impersonate header yet) → backend audits start.
    await api.post(`/admin/impersonate/${userId}`, {});
    // Now flip the header on and reload so /me returns the target persona.
    useAuthStore.getState().setImpersonateUserId(userId);
    window.location.assign('/');
}
/** Exit the "view as" session and return to the real admin. */
export async function stopImpersonation() {
    // POST while the impersonate header is still on → backend audits stop.
    try {
        await api.post('/admin/impersonate/stop', {});
    }
    catch {
        // Best-effort — even if the audit call fails we must still let the admin
        // exit (clearing the header locally is what actually ends the session).
    }
    useAuthStore.getState().setImpersonateUserId(null);
    window.location.assign('/');
}
